import { AnalyticsManager } from '@oy/analytics';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getPaymentInfo } from 'src/clients';
import {
  useAppSelector,
  useBusinessProfileData,
  useCheckMAMViewOnlyChildType,
  useEnv,
  usePathValidation,
  usePermissionData,
  useTranslate,
} from 'src/hooks';
import { useCheckMAMViewOnlyChildTypeProd } from 'src/hooks/useCheckMAMViewOnlyChildTypeProd';
import { useSectionValidation } from './hooks';

export const useSidebarImpl = () => {
  const { isProdEnv, currentEnv } = useEnv();
  const { isShowSection, isShowProduct } = useSectionValidation();
  const { routeIsActive } = usePathValidation();
  const { fetchPermission } = usePermissionData();
  const { triggerFetchChildType } = useCheckMAMViewOnlyChildType();
  const { triggerFetchChildTypeProd } = useCheckMAMViewOnlyChildTypeProd();
  const { lang } = useTranslate();
  const dispatch = useDispatch();
  const { data: businessProfileData } = useBusinessProfileData();
  const userRole = useAppSelector(state => state.auth.user?.roles?.[0] ?? '');

  useEffect(() => {
    triggerFetchChildType();
    triggerFetchChildTypeProd();
    fetchPermission();
  }, [
    userRole,
    triggerFetchChildType,
    triggerFetchChildTypeProd,
    fetchPermission,
    currentEnv,
  ]);

  useEffect(() => {
    const fetchPaymentInfo = async () => {
      dispatch({
        type: 'SET_GENERAL_LOADING',
        payload: true,
      });
      try {
        const { data } = await getPaymentInfo();
        if (data) {
          AnalyticsManager.instance().setUserProperties({
            username: data.data?.b2xUser?.username || '',
            account_type: data.data?.accountType || '',
            receiving_account:
              data.data?.merchantWebCheckout?.receivingAccount || '',
            receiving_account_name:
              data.data?.merchantWebCheckout?.receivingAccountName || '',
            receiving_bank_code:
              data.data?.merchantWebCheckout?.receivingBankCode || '',
          });
          dispatch({
            type: 'SET_MAIN_INFO',
            payload: data.data,
          });
        }
      } catch {
        //
      }
      dispatch({
        type: 'SET_GENERAL_LOADING',
        payload: false,
      });
    };
    fetchPaymentInfo();
  }, [userRole, dispatch, currentEnv]);

  const businessProfileStr = JSON.stringify(businessProfileData || {});

  useEffect(() => {
    const businessProfile = JSON.parse(businessProfileStr || '{}');
    const properties = {
      user_role: userRole,
      language: lang,
      ...businessProfile,
    };
    AnalyticsManager.instance().setUserProperties(properties);
  }, [businessProfileStr, userRole, lang]);

  const state = {
    isProdEnv,
  };

  return {
    state,
    isShowSection,
    isShowProduct,
    routeIsActive,
  };
};
